export const parcelStatusVariants = {
  cards: 'cards',
  table: 'table',
  previewDetail: 'previewDetail',
}

export const stylesByVariant = {
  [parcelStatusVariants.cards]: {
    iconSize: 24,
    textStyle: 'bodyMBold',
  },
  [parcelStatusVariants.table]: {
    iconSize: 16,
    textStyle: 'bodySRegular',
  },
  [parcelStatusVariants.previewDetail]: {
    iconSize: 24,
    textStyle: 'bodyMBold',
  },
}
